var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTuffBuilding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.972 25H29.65c.193 0 .35-.155.35-.344V17h-8.083a6.002 6.002 0 01-11.834 0H2v7.656c0 .19.158.344.35.344h5.622zm2.111-10H2V9.93c0-.834.512-1.581 1.29-1.903l11.9-4.87a2.14 2.14 0 011.615 0l11.904 4.87A2.067 2.067 0 0130 9.93V15h-8.083a6.002 6.002 0 00-11.834 0zM20 16a4 4 0 11-8 0 4 4 0 018 0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTuffBuilding);
export default __webpack_public_path__ + "static/media/tuffBuilding.7f3f278120e295d6ee5d8331769b88ce.svg";
export { ForwardRef as ReactComponent };